export default __webpack_public_path__ + "static/poster1-722395a045be12ede7adca7693460fa2.webp";